export * from './article.model';
export * from './actualite.model';
export * from './article-list-config.model';
export * from './errors.model';
export * from './user.model';
export * from './filter.model';
export * from './etablissement.model';
export * from './pays.model';
export * from './panier.model';
export * from './ligne-panier.model';
export * from './civilite.model';
export * from './entete-commande.model';
export * from './ligne-commande.model';


// WEBPACK FOOTER //
// ./src/app/shared/models/index.ts